import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { AdminShell, AdminTopBar, AdminBrand, AdminNav, AdminMain } from '../../styles/adminStyles';
import { Link } from 'react-router-dom';
import LanguageSwitcher from '../LanguageSwitcher';
import { usePortalT } from '../../i18n/usePortalT';

export default function ProtectedRoute() {
  const { user, loading, isAdmin, logout } = useAuth();
  const { t } = usePortalT();

  if (loading) {
    return (
      <AdminShell>
        <AdminMain><p>{t('common.loading')}</p></AdminMain>
      </AdminShell>
    );
  }

  if (!user || !isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <AdminShell>
      <AdminTopBar>
          <AdminBrand>{t('adminNav.brand')}</AdminBrand>
        <AdminNav>
          <Link to="/admin">{t('adminNav.pvp')}</Link>
          <Link to="/admin/activities">{t('adminNav.activities')}</Link>
          <Link to="/admin/reports">{t('adminNav.reports')}</Link>
          <Link to="/admin/appeals">{t('adminNav.appeals')}</Link>
          <Link to="/admin/rewards">{t('adminNav.rewards')}</Link>
          <span>{user.displayName || user.username}</span>
          <LanguageSwitcher compact />
          <button type="button" onClick={logout} style={{ background: 'none', border: 'none', cursor: 'pointer', fontWeight: 700 }}>
            {t('common.logout')}
          </button>
        </AdminNav>
      </AdminTopBar>
      <AdminMain>
        <Outlet />
      </AdminMain>
    </AdminShell>
  );
}
